/**
 *  @class
 *  @function MegaMenuSidebar
 */
if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.mega-menu-sidebar--button');
      this.content = this.querySelectorAll('.mega-menu-sidebar--content-inner');
      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseover', (event) => {
          this.onHover(event, button, i);
        });
      });
      const unveilActiveImages = () => {
        this.unveilImages(this.querySelector('.mega-menu-sidebar--content-inner.active'));
      };
      this.addEventListener('pointerenter', unveilActiveImages, { once: true, passive: true });
      this.addEventListener('focusin', unveilActiveImages, { once: true });
    }

    onHover(event, button, i) {
      this.content.forEach((content, index) => {
        content.classList.remove('active');
        if (i == index) {
          content.classList.add('active');
          this.unveilImages(content);
        }
      });
      this.buttons.forEach((this_button, index) => {
        this_button.classList.remove('active');
      });
      button.classList.add('active');
    }

    unveilImages(container) {
      if (!container) return;
      container.querySelectorAll('.mega-menu-sidebar--image-template').forEach((template) => {
        template.replaceWith(template.content.cloneNode(true));
      });
      if (!window.lazySizes || !window.lazySizes.loader) return;
      container.querySelectorAll('img.lazyload').forEach((image) => {
        window.lazySizes.loader.unveil(image);
      });
    }
  }
  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}
